/* eslint-disable @typescript-eslint/explicit-function-return-type */
import palette from 'live/services/theme'
import _ from 'lodash'

const defaultKpisColors = {
    light: {
        s2s: '#A0CE6D',
        w2w: '#6EADF7',
        p2p: '#FFCE55',
        rop: '#52C7E0',
        trip_in: '#A096E9',
        trip_out: '#F58989'
    },
    dark: {
        // currently the same as light mode - waiting for UX to define dark mode KPIs colors
        s2s: '#A0CE6D',
        w2w: '#6EADF7',
        p2p: '#FFCE55',
        rop: '#52C7E0',
        trip_in: '#A096E9',
        trip_out: '#F58989'
    }
}

const defaultChannelsColors = {
    light: ['#FF0000', '#FF7700', '#ECBD13', '#8CA300', '#00B8B8', '#006EDB', '#9C6BFF', '#FF6EFF'],
    // currently the same as light mode - waiting for UX to define dark mode KPIs colors
    dark: ['#FF0000', '#FF7700', '#ECBD13', '#8CA300', '#00B8B8', '#006EDB', '#9C6BFF', '#FF6EFF']
}

const theme = {
    ...palette,
    'light-shadow': '#faf9f9',
    'border-input-dark': '#292929',
    'gray-alternative': '#515D77',
    'modal-header': '#28334A',
    'text-header': '#FFFFFF',
    'input-disabled': '#EEEEEE',
    'input-text-disabled': '#868695',
    'run-status-bg': '#F5F5F5',
    white: '#FFFFFF',
    stand: '#868695',
    kpis: defaultKpisColors,
    channels: defaultChannelsColors,
    light: '#FFFFFF',
    hover: '#37A3EF'
}

export const darkMode = {
    'text-color': theme.white,
    'dash-background': theme['darker-backgrounds'],
    'gray-lighter': theme['main-tipography'],
    'gray-dark-bg': theme['auxiliar-typography'],
    'light-shadow': theme['darker-backgrounds'],
    'input-borders': theme['border-input-dark'],
    'input-borders': theme['auxiliar-typography'],
    steel: theme.white,
    'light-pink-borders': theme['main-tipography'],
    white: theme['gray-alternative'],
    'gray-alternative': theme.white,
    'dark-red': '#FFFFFF',
    'main-tipography': '#FFFFFF',
    'light-borders': theme['auxiliar-typography'],
    'modal-header': '#F5F5F5',
    'text-header': theme['darker-backgrounds'],
    'input-disabled': theme['main-tipography'],
    'input-text-disabled': theme['input-borders'],
    'run-status-bg': '#263046',
    stand: '#868695',
    kpis: defaultKpisColors,
    channels: defaultChannelsColors,
    light: theme.hover,
    'auxiliar-typography': '#FFFFFF'
}

export const getThemeCss = (theme, path) => {
    const properties = _.get(theme, `types.${path}`, {})

    let css = ''

    _.forOwn(properties, (value, key) => {
        css = css + `${key} : ${value};\n`
    })

    return css
}

export default theme
